/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import {
    useForm,
    Controller,
    useFieldArray
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
    TextField,
    Grid,
    Box,
    IconButton,
    InputAdornment
} from '@mui/material';
// @ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
// @ts-ignore
import { Delete02Icon, AddCircleIcon, Cancel01Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { getSeedListById, updateSeedList } from 'src/services/seedListService';
import type { BrandApiResponse, RootState } from '../types/types';
import { ERR_EMAIL_INVALID, LABEL_BTN_CANCEL, NEW_USER_ERROR_INVALID_FIRST_NAME, NEW_USER_ERROR_INVALID_LAST_NAME } from 'src/constants/constant';
import * as EmailValidator from 'email-validator';
import { checkEventPermission } from 'src/common/utility/utility';

interface PropsType {
    onClose: () => void;
    onRefresh: () => void;
    seedListId?: number;
}

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Please enter the title'),
    seeds: Yup.array()
        .of(
            Yup.object().shape({
                firstName: Yup.string().required('Please enter the first name').matches(
                      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
                      NEW_USER_ERROR_INVALID_FIRST_NAME
                    ),
                lastName: Yup.string().required('Please enter the last name').matches(
                      /^[a-zA-Z](?:[a-zA-Z -]*[a-zA-Z])?$/,
                      NEW_USER_ERROR_INVALID_LAST_NAME
                    ),
                email: Yup.string().email('Invalid email').required('Please enter the email').test(
                        'is-valid-email',
                        ERR_EMAIL_INVALID,
                        (value) => value === '' || EmailValidator.validate(value),
                      ),
            })
        )
        .min(1, 'At least one seed is required'),
});

function EditSeedList({onClose, onRefresh, seedListId}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [originalTitle, setOriginalTitle] = useState<string>('');
    const { user } = useSelector((state: RootState) => state.auth);

    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            title: '',
            seeds: [{ firstName: '', lastName: '', email: '' }],
        },
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'seeds',
    });

    const handleEditTitle = (): void => {
        setIsEditing(!isEditing);
    };

    const handleCancelEdit = (): void => {
        // Reset to original title when canceling
        setValue('title', originalTitle);
        setIsEditing(false);
    };

    // Fetch data
    useEffect(() => {
        getSeedListById(seedListId)
            .then((response) => {
                if (response.status === 200 && response.data.result === 1) {
                    const { seedList, seedListData } = response.data.data;
                    setOriginalTitle(seedList.title);
                    reset({
                        title: seedList.title,
                        seeds: seedListData,
                    });
                }
            })
            .catch((error) => {
                console.error("Error fetching Seed List:", error);
                // NotificationManager.error("Failed to load seed list");
            });
    }, [seedListId]);

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const onSubmit = async (data: any) => {
        setIsLoading(true);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const finalRequest = {
            seedListId: seedListId,
            clientId: user?.clientId ?? 0,
            title: data.title,
            modifiedBy: user?.id ?? 0,
            seeds: data.seeds,
        };

        updateSeedList(finalRequest)
          .then((res:BrandApiResponse) => {
            if (res.status === 200 && res.data.result === 1) {
              NotificationManager.success("Seed list updated successfully");
              onRefresh();
            } else {
              // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
              NotificationManager.error(res.data?.messages?.[0]?.message || "Update failed");
            }
          })
          .catch((err) => {
            console.error("Update error:", err);
            NotificationManager.error("An error occurred during update");
          })
          .finally(() => setIsLoading(false));
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                void handleSubmit(onSubmit)(e);
            }}
            noValidate
        >
            <div className="relative  px-[16px] pt-[10px]  pb-[50px]">
                
                    {/* Title */}
                    <Box mb={4}>
                        <Controller
                            name="title"
                            control={control}
                            render={({ field }) => (
                                <div className={`mb-[5px] w-full relative role-input-container ${!isEditing ? 'disabled' : ''}`} style={{ marginBottom: '30px' }}>
                                    <TextField
                                        {...field}
                                        fullWidth
                                        label="Title*"
                                        variant="outlined"
                                        autoComplete="off"
                                        InputProps={{
                                            style: {
                                                textAlign: "center",
                                                color: '#343434',
                                                fontSize: '18px',
                                                fontWeight: '700',
                                                WebkitTextFillColor: '#343434',
                                                padding: '9px 14px 9px 25px'
                                            },
                                            placeholder: 'Title*',
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    {!isEditing ? (
                                                        <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleEditTitle}>
                                                            <img src={'/assets/images/icons/EditIcon.svg'} width={15} height={15} alt="" />
                                                        </div>
                                                    ) : (
                                                        <div className="btn btn-circle btn-circle-small bg-[#fff] hover:bg-[#f5f5f5] border-0 ml-2" style={{ padding: '4px', width: '2rem', height: '2rem', minHeight: '2rem' }} onClick={handleCancelEdit}>
                                                            <HugeiconsIcon
                                                                icon={Cancel01Icon}
                                                                size={20}
                                                                color="#3a3a3a"
                                                                strokeWidth={0.2}
                                                            />
                                                        </div>
                                                    )}
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            '& input': {
                                                textAlign: 'center',
                                            },
                                            '& label': {
                                                textAlign: 'center',
                                            },
                                            backgroundColor: '#F5F5F5',
                                        }}
                                        disabled={!isEditing}
                                        error={!!errors.title}
                                    />
                                    {errors.title && (
                                        <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                            <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                            {errors.title?.message}
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    </Box>

                    {/* Seeds Grid */}
                    { fields.map((item, index) => (
                        <Grid container spacing={2} alignItems="center" key={item.id}>
                            <Grid item xs={12} sm={3}>
                                <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.firstName`}
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                           <TextField
                                            {...field}
                                            label="First Name*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.firstName}
                                        />
                                        {errors.seeds?.[index]?.firstName && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                        <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                        {errors.seeds?.[index]?.firstName?.message} 
                                    </div>
                                )}
                                        </>
                                     
                                    )}
                                />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={3}>
                                 <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.lastName`}
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                          <TextField
                                            {...field}
                                            label="Last Name*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.lastName}
                                        />
                                          {errors.seeds?.[index]?.lastName && (
                                    <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                            <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                            {errors.seeds?.[index]?.lastName?.message} 
                                        </div>
                                    )}
                                        </>
                                      
                                    )}
                                />
                                </div>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                 <div className="mb-[30px]">
                                <Controller
                                    name={`seeds.${index}.email`}
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                        <TextField
                                            {...field}
                                            label="Email*"
                                            fullWidth
                                            variant="outlined"
                                            error={!!errors.seeds?.[index]?.email}
                                        />
                                        {errors.seeds?.[index]?.email && (
                                            <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                                <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1" />
                                                {errors.seeds?.[index]?.email?.message}
                                            </div>
                                        )}
                                        </>
                                    )}
                                />
                            </div>
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                 <div className="mb-[30px]">
                                <IconButton
                                    color="error"
                                    onClick={() => remove(index)}
                                    disabled={fields.length === 1}
                                >
                                    <HugeiconsIcon
                                        icon={Delete02Icon}
                                        size={20}
                                        color="#de3339"
                                    // strokeWidth={0.2}
                                    />
                                </IconButton>
                                {
                                    fields.length === index + 1 &&
                                    <IconButton
                                        onClick={() => append({ firstName: '', lastName: '', email: '' })}
                                    >
                                        <HugeiconsIcon
                                            icon={AddCircleIcon}
                                            size={20}
                                            color="#3a3a3a"
                                            strokeWidth={0.2}
                                        />
                                    </IconButton>
                                }
                                </div>
                            </Grid>
                        </Grid>
                    ))}
                
            </div>

            {/* Bottom Buttons */}
            <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button
                        type="button"
                        className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc]"
                        disabled={isLoading}
                        onClick={() => onClose()}
                    >
                        {LABEL_BTN_CANCEL}
                    </button>
                </div>
                <div className="w-full relative col-span-3">
                    <button
                        type="submit"
                        disabled={isLoading || !checkEventPermission('SEEDLIST_UPDATE')}
                        className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]"
                    >
                        {!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </button>
                </div>
            </div>
        </form>
    );
}

export default EditSeedList;
